import { render } from "./bottom-nam.vue?vue&type=template&id=267b82a5&scoped=true"
import script from "./bottom-nam.vue?vue&type=script&lang=js"
export * from "./bottom-nam.vue?vue&type=script&lang=js"

import "./bottom-nam.vue?vue&type=style&index=0&id=267b82a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267b82a5"]])

export default __exports__